const StarSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill="none"><path fill="#FFEFCF" d="M13.316 4.56H9.607L8.46 1.005a.996.996 0 0 0-.947-.694.997.997 0 0 0-.947.694L5.421 4.559H1.713a.997.997 0 0 0-.947.694c-.134.413.012.866.362 1.122l3 2.196-1.146 3.553c-.133.413.013.866.362 1.122a.99.99 0 0 0 1.17 0l3-2.197 3.002 2.197a.99.99 0 0 0 1.17 0c.35-.256.495-.709.362-1.122L10.901 8.57l2.977-2.18c.261-.181.432-.484.432-.827a.999.999 0 0 0-.994-1.004Z"/></svg>
    )
}

export default StarSvg;